import React from 'react';
import { MDBadgeRoot } from './MDBadgeRoot';

interface MDBadgeProps {
  color?:
    | 'primary'
    | 'secondary'
    | 'info'
    | 'success'
    | 'warning'
    | 'error'
    | 'light'
    | 'dark';
  variant?: 'gradient' | 'contained';
  size?: 'xs' | 'sm' | 'md' | 'lg';
  circular?: boolean;
  indicator?: boolean;
  border?: boolean;
  container?: boolean;
  children?: React.ReactNode;
  [key: string]: any;
}

const MDBadge = ({
  color = 'info',
  variant = 'gradient',
  size = 'sm',
  circular = false,
  indicator = false,
  border = false,
  container = false,
  children = false,
  ...rest
}: MDBadgeProps) => (
  <MDBadgeRoot
    {...rest}
    ownerState={{
      color,
      variant,
      size,
      circular,
      indicator,
      border,
      container,
      children,
    }}
    color="default"
  >
    {children}
  </MDBadgeRoot>
);

MDBadge.displayName = 'MDBadge';

export { MDBadge };
